import React from "react";

const LabelValueRow = ({ label, value, placeholder = '-' }) => {
  return (
    <div className="d-flex">
      <strong className="me-2" style={{ minWidth: "140px" }}>{label}</strong>
      <span>{value !== 0 && value !== null && value !== undefined ? value : placeholder}</span>
    </div>
  );
};

export default LabelValueRow;
